import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useMemo } from 'react';
import { __OPERATION__MANAGEMENT__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';
interface MicroServizioConsumerListComponentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  onBlur?: () => void;
  error?: boolean;
}

interface MicroservicesConsumerBE {
  endpoint: string;
  key: {
    microservizio: string;
  };
}

const MicroServizioConsumerListComponent = ({
  disabled,
  onChange,
  onBlur = () => {
    return;
  },
  value,
  error,
  required,
}: MicroServizioConsumerListComponentProps): React.ReactElement => {
  const [microservices] = useHttpFetch<HttpResponseList<MicroservicesConsumerBE>, Array<ItemVM>>(
    `${__OPERATION__MANAGEMENT__}/microservizi`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response: AxiosResponse<HttpResponseList<MicroservicesConsumerBE>>) => {
        return response.data.payload.list.map((item) => {
          const itemResult: ItemVM = {
            id: item?.key?.microservizio,
            value: item?.key?.microservizio,
          };
          return itemResult;
        });
      },
    }
  );
  const microservicesList = useMemo(() => {
    const data = (microservices?.data as Array<ItemVM>) || [];
    return data;
  }, [microservices.data]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="microservizioconsumer-label">
        {required ? 'Microservizio consumer *' : 'Microservizio consumer'}
      </InputLabel>
      <PmiSelect
        labelId="microservizioconsumer-label"
        id="microConsumer"
        name="microConsumer"
        value={value}
        label={required ? 'Microservizio consumer *' : 'Microservizio consumer'}
        onChange={onChange}
        disabled={disabled}
        error={error}
        onBlur={onBlur}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {microservicesList.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MicroServizioConsumerListComponent.displayName = 'MicroServizioConsumer item component';

const MicroConsumerList = memo(MicroServizioConsumerListComponent);

export default MicroConsumerList as typeof MicroServizioConsumerListComponent;
